import DatabaseModel from './DatabaseModel.js';

var SwiftCache = Object.create(DatabaseModel);

SwiftCache.model = 'swiftcache';
SwiftCache.modelFront = 'swiftcache';

export default SwiftCache;
